/* eslint-disable @typescript-eslint/no-unnecessary-type-parameters */
import { endOfDay, subDays, subSeconds } from 'date-fns';
import { PlainRangeInterface } from '../models/range.interface';

export function tsRangeMax<
  StartBoundary extends 'finite' | 'infinite' = 'finite',
  EndBoundary extends 'finite' | 'infinite' = 'finite',
  PlainType extends string | number = string,
  PlainStartType extends PlainType | null = StartBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
  PlainEndType extends PlainType | null = EndBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
  ReturnType = EndBoundary extends 'infinite' ? Date | null : Date,
>(
  range: PlainRangeInterface<StartBoundary, EndBoundary, PlainType, PlainStartType, PlainEndType>,
): ReturnType {
  if (range.end === null) {
    return null as ReturnType;
  }
  const end = new Date(range.end);
  if (range.inclusiveEnd) {
    return end as ReturnType;
  }
  return subSeconds(end, 1) as ReturnType;
}

export function dateRangeMax<
  StartBoundary extends 'finite' | 'infinite' = 'finite',
  EndBoundary extends 'finite' | 'infinite' = 'finite',
  PlainType extends string | number = string,
  PlainStartType extends PlainType | null = StartBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
  PlainEndType extends PlainType | null = EndBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
  ReturnType = EndBoundary extends 'infinite' ? Date | null : Date,
>(
  range: PlainRangeInterface<StartBoundary, EndBoundary, PlainType, PlainStartType, PlainEndType>,
): ReturnType {
  if (range.end === null) {
    return null as ReturnType;
  }
  const end = new Date(range.end);
  if (range.inclusiveEnd) {
    return endOfDay(end) as ReturnType;
  }
  return endOfDay(subDays(end, 1)) as ReturnType;
}

export function intRangeMax<
  StartBoundary extends 'finite' | 'infinite' = 'finite',
  EndBoundary extends 'finite' | 'infinite' = 'finite',
  PlainType extends string | number = string,
  PlainStartType extends PlainType | null = StartBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
  PlainEndType extends PlainType | null = EndBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
  ReturnType = EndBoundary extends 'infinite' ? number | null : number,
>(
  range: PlainRangeInterface<StartBoundary, EndBoundary, PlainType, PlainStartType, PlainEndType>,
): ReturnType {
  if (range.end === null) {
    return null as ReturnType;
  }
  const end: number = typeof range.end === 'string' ? parseInt(range.end, 10) : range.end;
  if (range.inclusiveEnd) {
    return end as ReturnType;
  }

  return (end - 1) as ReturnType;
}
